import React, { useState, PureComponent } from "react";
import { FadeLoader } from "react-spinners";
import { Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Carousel from "react-bootstrap/Carousel";
import "../App.css";
import Header from "./header";
import SideNav from "./sidenav";
import Action1 from "../assets/images/Action-1.png";
import { Button } from "react-bootstrap";
import Back from "../assets/images/arrow2.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import Pagination from "react-js-pagination";
import { adminPaymentAction } from "../redux/actions/reportAction";
const init = {
  search: "",
  endDate: "",
  startDate: "",
};
const ReportAdmin = () => {
  const [iState, updateState] = useState(init);
  const { search, endDate, startDate } = iState;
  const [activePage, updateActivePage] = useState(1);
  const [serialNo, updateSerialNo] = useState(10);
  const dispatch = useDispatch();
  const { adminPaymentReportsData, loader } = useSelector(
    (state) => state.dashboard,
  );

  const ownerData = JSON.parse(window.localStorage.getItem("ownerLogin"));
  // console.log("dfdfdfgdfgsdf", id);
  useEffect(() => {
    dispatch(adminPaymentAction({ storeId: ownerData?._id }));
  }, []);

  const handleInput = (e) => {
    const { name, value } = e?.target;
    updateState({ ...iState, [name]: value });
  };

  const handlePageChange = (pageNumber) => {
    let ser = pageNumber * 10;
    updateSerialNo(ser);
    updateActivePage(pageNumber);
    dispatch(adminPaymentAction({ storeId: ownerData?._id }));
  };

  const handleFilteredData = () => {
    dispatch(adminPaymentAction({ storeId: ownerData?._id }));
  };

  const handleRefresh = () => {
    updateState(init);
    dispatch(adminPaymentAction({ storeId: ownerData?._id }));
  };

  return (
    <div>
      {loader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 9999,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <FadeLoader color="#f56608" />
        </div>
      )}
      <Header />
      <SideNav />
      <div class="WrapperArea">
        <div class="WrapperBox">
          <div class="TitleBox">
            <div>
              <h4 class="Title">
                {" "}
                <Link to="/Report-management">
                  {" "}
                  <img src={Back} />
                </Link>
                Admin Payment Reports
              </h4>
            </div>
            <button className="DownloadExcel">Export to Excel </button>
          </div>
          <div className="Small-Wrapper">
            <div class="FilterMain">
              <div class="form-group">
                <label>Search</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search..."
                  name="search"
                  value={search}
                  onChange={handleInput}
                />
              </div>
              <div class="form-group">
                <label> From</label>
                <input
                  type="date"
                  class="form-control"
                  name="startDate"
                  value={startDate}
                  onChange={handleInput}
                />
              </div>
              <div class="form-group">
                <label> To</label>
                <input
                  type="date"
                  class="form-control"
                  name="endDate"
                  value={endDate}
                  onChange={handleInput}
                />
              </div>

              <div class="form-group ">
                <label>&nbsp;</label>
                <button
                  class="Button AddButton d-inline"
                  onClick={handleFilteredData}
                >
                  Apply
                </button>
                <button
                  class="Button AddButton d-inline"
                  onClick={handleRefresh}
                >
                  {" "}
                  <i className="fa fa-refresh"></i>{" "}
                </button>
              </div>
            </div>
            <div class="TableList">
              <table style={{ width: "130%" }}>
                <thead>
                  <tr>
                    <th>Transaction Id</th>
                    <th>Transaction Date </th>
                    <th>Store Id</th>
                    <th>Store Name</th>
                    <th>Order Id</th>
                    <th>Order Date</th>
                    <th>Order Quantity</th>
                    <th>Total Order Value</th>
                    <th>Taxes Included </th>
                    <th>Store Earning</th>
                    <th>Admin's Commission</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {adminPaymentReportsData?.data?.result.length > 0 ? (
                    <>
                      {adminPaymentReportsData?.data?.result?.map(
                        (ele, index) => {
                          // console.log("ele", ele)
                          return (
                            <>
                              <tr>
                                <td>{ele?.orderNumber}</td>
                                <td>{ele?.createdAt?.split("T")[0]} </td>
                                <td>{ele?.store?.storeNumber}</td>
                                <td>{ele?.store?.storeName}</td>
                                <td>{ele?.orderNumber}</td>
                                <td>{ele?.createdAt?.split("T")[0]}</td>
                                <td>{ele?.orderData?.length}</td>
                                <td>{ele?.paymentAmount}</td>
                                <td>{ele?.tax}</td>
                                <td>{ele?.paymentAmount}</td>
                                <td>{ele?.adminComission}</td>
                                {/* <td></td> */}
                                <td>
                                  <span class="Gray">{ele?.status}</span>
                                </td>
                              </tr>
                            </>
                          );
                        },
                      )}
                    </>
                  ) : (
                    <tr>
                      <td colSpan={12} className="text-center">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div class="Pagination">
              <p>
                {" "}
                Total records :{" "}
                <span> {adminPaymentReportsData?.data?.total || 0}</span>
              </p>
              <ul>
                {adminPaymentReportsData?.data?.result > 0 && (
                  <Pagination
                    activePage={activePage}
                    itemsCountPerPage={10}
                    totalItemsCount={adminPaymentReportsData?.data?.result || 0}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                  />
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <div class="WrapperArea">
                <div class="WrapperBox">
                    <div class="TitleBox">
                        <div>
                            <h4 class="Title"> <Link to="/Report-management" > <img src={Back} /></Link>Admin Payment  Reports</h4>
                        </div>
                        <button className="DownloadExcel" >Export to Excel </button>
                    </div>
                    <div className="Small-Wrapper">
                        <div class="FilterMain">
                            <div class="form-group">
                                <label>Search</label>
                                <input type="text" class="form-control" placeholder="Search..." />
                            </div>
                            <div class="form-group">
                                <label> From</label>
                                <input type="date" class="form-control" />
                            </div>
                            <div class="form-group">
                                <label> To</label>
                                <input type="date" class="form-control" />
                            </div>
                          
                            <div class="form-group ">
                                    <label>&nbsp;</label>
                                    <button class="Button AddButton d-inline">Apply</button>
                                    <button class="Button AddButton d-inline"> <i className="fa fa-refresh"></i> </button>
                                </div>
                        </div>
                        <div class="TableList">
                            <table style={{ width: "130%" }}>
                                <thead>
                                    <tr>
                                        <th >Transaction Id</th>
                                        <th>Transaction Date </th>
                                        <th>Store  Id</th>
                                        <th>Store  Name</th>
                                        <th>Order Id</th>
                                        <th>Order Date</th>
                                        <th>Order Quantity</th>
                                        <th>Total Order Value</th>
                                        <th>Taxes Included </th>
                                        <th>Store Earning</th>
                                        <th>Admin's Commission</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>VNU101</td>
                                        <td>22 June 2022 </td>
                                        <td>STORE1245</td>
                                        <td>Burger King</td>
                                        <td>ORDERID</td>
                                        <td>22 June 2022 </td>
                                        <td>02</td>
                                        <td>$3423</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td><span class="Orange">Completed</span></td>
                                    </tr>
                                    <tr>
                                        <td>VNU101</td>
                                        <td>22 June 2022 </td>
                                         <td>STORE1245</td>
                                        <td>Burger King</td>
                                        <td>ORDERID</td>
                                        <td>22 June 2022 </td>
                                        <td>02</td>
                                        <td>$3423</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td><span class="Orange">Completed</span></td>
                                    </tr>
                                    <tr>
                                        <td>VNU101</td>
                                        <td>22 June 2022 </td>
                                         <td>STORE1245</td>
                                        <td>Burger King</td>
                                        <td>ORDERID</td>
                                        <td>22 June 2022 </td>
                                        <td>02</td>
                                        <td>$3423</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td><span class="Orange">Completed</span></td>
                                    </tr>
                                    <tr>
                                        <td>VNU101</td>
                                        <td>22 June 2022 </td>
                                         <td>STORE1245</td>
                                        <td>Burger King</td>
                                        <td>ORDERID</td>
                                        <td>22 June 2022 </td>
                                        <td>02</td>
                                        <td>$3423</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td>$56</td>
                                        <td><span class="Orange">Completed</span></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="Pagination">
                            <p> Total records : <span> 10</span></p>
                            <ul>
                                <li><a href="javascript:void(0);"><i class="fa fa-angle-double-left"></i></a></li>
                                <li><a href="javascript:void(0);"><i class="fa fa-angle-left"></i></a></li>
                                <li class="active"><a href="javascript:void(0);">1</a></li>
                                <li><a href="javascript:void(0);">2</a></li>
                                <li><a href="javascript:void(0);">3</a></li>
                                <li><a href="javascript:void(0);"><i class="fa fa-angle-right"></i></a></li>
                                <li><a href="javascript:void(0);"><i class="fa fa-angle-double-right"></i></a></li>
                            </ul>
                        </div>  
                    </div>

                </div>
            </div> */}
    </div>
  );
};
export default ReportAdmin;
